export { default } from './Icon'

export { IconsList } from './Icon.const'
